<template>
  <div>
    <div class="footer">
      <div class="nav_list center_box fc" v-show="!hideNav">
        <div
          class="nav_item"
          v-for="nav_item in $store.getters.footer_navigation"
          :key="nav_item.id"
          @click="jump_url(nav_item.id)"
        >
          {{ nav_item.title }}
        </div>
      </div>
      <template v-if="$store.getters.config.FOOTER_CONNECTION">
        <div v-html="$store.getters.config.FOOTER_CONNECTION.value"></div>
      </template>
      <!-- <div class="m_b9">{{ $store.getters.config.web_copyright.value }}</div>
			<div class="fcc m_b10">
				<img class="icon_badge" referrerpolicy="no-referrer" src="@/assets/images/login/badge.png" />
				<span>{{ $store.getters.config.web_miitbeian.value }}</span>
			</div>
			<div class="m_b17">
				<span>{{ $store.getters.config.customer_phone1.title }}：{{
					$store.getters.config.customer_phone1.value
				}}</span>
				&ensp;
				<span>{{ $store.getters.config.customer_phone2.title }}：{{
					$store.getters.config.customer_phone2.value
				}}</span>
			</div> -->
      <div class="icon_footer">
        <img
          referrerpolicy="no-referrer"
          v-for="img_item in footer_links"
          :key="img_item.id"
          :src="img_item.cover_path"
          @click="openUrl(img_item.url)"
        />
      </div>
    </div>
    <div class="mobile_tab flex">
      <div
        v-for="(item, index) in tabs"
        :key="index"
        @click="onChangeTab(item.path)"
        :class="['tab_item', active_tab === index && 'active_tab']"
      >
        <img
          :src="active_tab === index ? item.active_icon : item.icon"
          alt=""
        />
        <div>{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpGet } from "@/apis";
export default {
  name: "Footer",
  props: ["hideNav"],
  data() {
    return {
      footer_links: [],
      active_tab: null,
      tabs: [
        {
          label: "首页",
          icon: require("@/assets/images/tabs/home.png"),
          active_icon: require("@/assets/images/tabs/active_home.png"),
          path: "/dashboard",
        },
        {
          label: "个人中心",
          icon: require("@/assets/images/tabs/mine.png"),
          active_icon: require("@/assets/images/tabs/active_mine.png"),
          path: "/personal_center",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.active_tab = this.tabs.findIndex((v) => v.path === to.path);
    },
  },
  mounted() {
    this.active_tab = this.tabs.findIndex((v) => v.path === this.$route.path);
    this.getFooterLink();
  },
  methods: {
    async getFooterLink() {
      const res = await httpGet("/api/information/footer_link");
      if (res.code === 200) {
        this.footer_links = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    jump_url(id) {
      this.$router.push("/navigation?nav_index=" + id);
    },
    onChangeTab(path) {
      this.$router.push(path);
    },
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>
  
<style lang="scss" scoped>
.footer {
  box-sizing: border-box;
  padding-bottom: 129px;
  font-size: 12px;
  font-family: AppleSystemUIFont;
  color: #909399;
  text-align: center;
  line-height: 15px;

  .nav_list {
    justify-content: center;
    height: 48px;
    margin-top: 61px;
    font-size: 16px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
    background: linear-gradient(180deg, #1f9ff9 0%, #0071c2 100%);

    .nav_item {
      height: 14px;
      margin-right: 24px;
      padding-right: 24px;
      line-height: 14px;
      border-right: 1px solid rgba(255, 255, 255, 0.4);
      cursor: pointer;
    }

    .nav_item:last-child {
      margin-right: 0;
      border-right: 0;
    }
  }

  .m_b9 {
    padding-top: 24px;
    margin-bottom: 12px;
  }

  .m_b10 {
    margin-bottom: 10px;
  }

  .m_b17 {
    margin-bottom: 23px;
  }

  .icon_badge {
    width: 22px;
    margin-right: 5px;
  }

  .icon_footer {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 30px;
    width: 646px;
    margin: 0 auto;

    img {
      width: 90px;
      height: 38px;
      cursor: pointer;
    }
  }
}

/* Pc */
@media screen and (min-width: 980px) {
  .mobile_tab {
    display: none;
  }
}

/* Mobile */
@media screen and (max-width: 980px) {
  // .footer {
  //   display: none;
  // }

  .mobile_tab {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    background-color: #fff;
    border-top: 1px solid #dcdfe6;

    .tab_item {
      flex: 1;
      text-align: center;
      font-size: 14px;
      padding: 6px 0;

      img {
        width: 24px;
        height: 21px;
      }
    }

    .active_tab {
      color: #0f8cff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/Footer.vue